// extracted by mini-css-extract-plugin
export default {"footerDisclaimer":"HyUhZM","disabledButton":"GvEZ4t","chooseButtonTooltipContentWrapper":"ULVedh"};